"use client";

import Image from "next/image";
import { useRouter } from "next/navigation";

export default function NotFound() {
  const router = useRouter();

  const goHome = () => {
    router.push("/");
  };

  return (
    <div className="flex flex-col justify-center items-center h-screen">
      <Image
        src="/images/svg/not_found.svg"
        alt="not_found"
        width={200}
        height={200}
        priority={true}
        quality={100}
        className="mb-2"
      />
      <p className="text-black dark:text-white t-title16 customDirection mb-2">
        متاسفانه صفحه مورد نظر یافت نشد.
      </p>
      <button className="t-title16 dark:text-blue-400 py-2 px-4" onClick={goHome}>
        رفتن به خانه
      </button>
    </div>
  );
}
